import React from 'react';
import { ICONIFY } from '../../../Constants/iconify';
import { Stack } from '@mui/material';
import CommonNode from './CommonNode';
import NodeWrapper from './NodeWrapper';
import OptionsNode from './OptionsNode';

function CheckboxNode({ data, isConnectable }) {

    return (
        <NodeWrapper nodeId={data?.id}>
            <OptionsNode
                data={data}
                icon={ICONIFY.CHECKBOX}
            />
        </NodeWrapper>
    );
};

export default CheckboxNode